import { inject, Injectable } from '@angular/core';
import { HttpHelper } from '@ck-core/ck-auth';
import { map, Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { GlobalSettings } from '../models/global-settings/global-settings.model';
import { ApiResponse } from '../models/press/press.model';

@Injectable({ providedIn: 'root' })
export class GlobalSettingsService {
    private readonly http = inject(HttpHelper);
    private readonly queryBaseUrl = environment.queryUrl;
    private readonly commandBaseUrl = environment.commandUrl;
    private readonly authBaseUrl = environment.apiAuthUrl;

    getBySite(siteId: string): Observable<GlobalSettings | null> {
        return this.http
            .get(`${this.queryBaseUrl}sites?id=${siteId}`)
            .pipe(map((response) => (response as ApiResponse<GlobalSettings>).data ?? null));
    }

    save(payload: GlobalSettings): Observable<ApiResponse<GlobalSettings>> {
        return this.http
            .post(`${this.commandBaseUrl}sites`, payload)
            .pipe(map((response) => response as ApiResponse<GlobalSettings>));
    }

    UpdateTenantInfo(tenantId: string, model: any) {
        return this.http.put(`${this.authBaseUrl}tenants/${tenantId}`, model);
    }

    public GetSite(data: any, tenantId: any) {
        let headers: any = {};
        if (tenantId) {
            headers['x-tenant-id'] = tenantId;
        }

        return this.http.post(`${this.queryBaseUrl}sites/paginate`, data, {}, headers);
    }
}
